module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "calibre3"
  }, [_vm._v("Erster Akt")]), _vm._v(" "), _c('p', {
    staticClass: "stage"
  }, [_vm._v("Die Kapitelstube des Neumünsters zu Würzburg. In\nder Hinterwand eine Bogentür nach der Kirche. Rechts Fenster mit\nNische. Im übrigen Chorstühle an den Wänden und ein langer leerer\nTisch, von Stühlen umgeben, in der Mitte des großen Raumes. Martin\nist beschäftigt, grüne Reiser anzunageln, welche Finkenmäuslin und\nKunzlin aus einem Korbe ihm zureichen. Am Tisch sitzt Lorenz\nLöffelholz, ein nasses Tuch um den Kopf gewunden, und hat Schriften\nvor sich aufgehäuft. In einer Fensternische der Rektor Besenmeyer\nund Bezold, der Schultheiß von Ochsenfurt, die Vorgänge auf der\nStraße durchs offene Fenster beobachtend. Stephan von Menzingen,\nein etwa vierzigjähriger Ritter in vollem Harnisch, sitzt\nnachlässig in einem der Chorstühle.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Der Schultheiß")]), _vm._v(". Setzt Euch, Bruder\nRektor, Ihr seid müde!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Rektor Besenmeyer")]), _vm._v(". Schütt dich der\nRitt, Bruder Schultheiß! Necdum omnis hebet effoeto in corpore\nsanguis: noch ist nicht alles Blut im alten Leibe vertrocknet. Was\ndenkt Ihr von mir? Wer ist dieser, der auf dem weißen Gaul?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Der Schultheiß")]), _vm._v(". Der Fettwanst, den\ndas Rößlein kaum tragen kann?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Löffelholz")]), _vm._v(". Wenn Ihr nit wißt, was\neine volle Sau ist, Bruder Rektor, so seht Euch den Jacob Kohl\nan.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Rektor Besenmeyer")]), _vm._v(". Ist es der Jacob\nKohl? Sieht nit fast aus wie ein großer Kriegsmann.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Der Schultheiß")]), _vm._v(". Sind ihm auch\nzuallererst die Federn ein wenig gewachsen; hat bis hieher\nschwerlich wohl ein'n toten Mann gesehen gehabt.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Löffelholz")]), _vm._v(". Versteht er sich nit\nauf Kriegshändel, so tuet er sich desto meh herfür, stehet mit dem\nMaul und der Weinkannen in der Trinkstuben desto baß seinen Mann.\nHöret doch zu, wie sie ihn anschreien! »Hans um und um« ist gar\nwohlgelitten, wird aber dem Bischof sein Schloß wohl schwerlich ab\ndem Berg stoßen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Der Schultheiß")]), _vm._v(". Es war dann Sach,\ndaß es vor Dräuen umfiel – –")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Menzingen")]), _vm._v(". Wird der Versammlungsrat\nhie Sitzung halten?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Löffelholz")]), _vm._v(". Ja, Bruder, an alle\nHauptleut aller Haufen um Würzburg ist Ladung ergangen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Menzingen")]), _vm._v(". Es tat not, daß wir uf\nfürgebrachte Instruktion "), _c('a', {
    staticClass: "pcalibre pcalibre1 pcalibre3 pcalibre2",
    attrs: {
      "id": "page21",
      "title": "r_a_5/gary"
    }
  }), _vm._v(" und Handlung Bescheid erhielten, damit anheims zu\nreiten gen Rothenburg.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Löffelholz")]), _vm._v(". Leid dich, Bruder\nMenzingen: fasse dich mit der Geduld. – –")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Martin")]), _vm._v(". Gib her, Finkenmäuslin!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Löffelholz")]), _vm._v(". Mach flugs, Martin! Du\nmußt mit Schriften aufs Rathaus!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Martin")]), _vm._v(". Wohl, wohl, Bruder.\n"), _c('span', {
    staticClass: "regie"
  }, [_vm._v("Er singt.")])]), _vm._v(" "), _c('p', {
    staticClass: "leftmarg"
  }, [_vm._v("    Winter, du mußt Urlaub han,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\n    das hab ich wohl vernommen."), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\n    Was mir der Winter hat angetan,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\n    das klag ich diesem Sommer.")]), _vm._v(" "), _c('p', {
    staticClass: "leftmarg"
  }, [_vm._v("Was machst du für ein Gesicht, Finkenmäuslin?\nHe, du, Kunzlin! Weißt nit, daß sich das Jubeljahr anfahet?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Kunzlin")]), _vm._v(". Ei freilich, Bruder!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Martin")]), _vm._v(". So mach einen Sprung und\nschrei juhu!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Kunzlin")]), _vm._v(" "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("springt\nund schreit")]), _vm._v(". Juhu!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Martin")]), _vm._v(". Kotz Lung, wo ist mein\nHammer? Gib her!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Finkenmäuslin")]), _vm._v(". Ich hab ihn nit!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Martin")]), _vm._v(". Gib her!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Menzingen")]), _vm._v(". Er hat ihn nit. Hörst du\ndann nit, du Partekenhengst?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Martin")]), _vm._v(". Wohlan, Bruder! ich hab oft\ngenung den Brotreigen vor der Bauern Türen mitsingen helfen. Itzt\nsingen die Bauern den Brotreigen vor den Schlössern und Häusern\nihrer Herrschaft. Aber einen so großmerklichen hab ich mein Tag nit\nmitgesungen. Gib her den Hammer!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Finkenmäuslin")]), _vm._v(". Potz dieser und\njener, ich hab ihn nit.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Martin")]), _vm._v(" "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("greift\nin Finkenmäuslins Tasche und holt ihn heraus")]), _vm._v(". Jez, was ist\ndas? Bah!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Finkenmäuslin")]), _vm._v(". Wie ist das\nzugangen?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Martin")]), _vm._v(". Wie ist das zugangen? Ja,\nitzt ratet! Wofür hab ich Occams Schule genossen? Was wißt Ihr von\nall meinen Subtilitäten? Zum Beispiel, Bruder Menzinger: kann Gott\nsich mit der Kreatur vereinen oder nit? Gott kann sich mit der\nKreatur vereinen. Der Vater ist der Sohn der Jungfrau Maria. Der\nHeilige Geist ist ein Mensch und der Sohn der Jungfrau. Der Vater,\nder nie gestorben, hätte sterben können, und der Sohn, welcher\ngestorben, hätte nie sterben können. Glaubt Ihr's nit? Euer Körper,\nBruder, kann intensiverweise an einem Orte unendlich weiß und\nintensiverweise ins unendliche schwarz sein. Verstehet Ihr das,\noder nit? "), _c('a', {
    staticClass: "pcalibre pcalibre1 pcalibre3 pcalibre2",
    attrs: {
      "id": "page22",
      "title": "r_a_5/gary"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Menzingen")]), _vm._v(", "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("lachend")]), _vm._v(". Gott helfe mir, nein, ich hab's nit\ngelernet!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Rektor Besenmeyer")]), _vm._v(", "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("lachend")]), _vm._v(". So freuet Euch, denn Ihr brauchet nichts zu\nverlernen. Hinderlich und elend ist uns unser Lernen. Wir haben\ngenung verdorbene Gehirne und Theologaster. Sie verstehen ihre\neigenen Bücher nit. Mit ihren exercitiis, copulatis, summis und\ndergleichen labyrinthis ist nichts getan. Mit ihren Quästionen\nwerden sie die Hölle nit auslöschen, mit ihren Distinktionen den\nHimmel nit aufschließen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Der Schultheiß")]), _vm._v(". Bruder Rektor!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Rektor Besenmeyer")]), _vm._v(". Oha!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Der Schultheiß")]), _vm._v(". Kennt Ihr den\nBerlinger von Angesicht?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Rektor Besenmeyer")]), _vm._v(". Den Götzen von\nBerlichingen mit der eisernen Hand?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Der Schultheiß")]), _vm._v(". Der dort auf dem\nmagern Klepper sitzt.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Rektor Besenmeyer")]), _vm._v(". Das kurze\nMännlein?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Der Schultheiß")]), _vm._v(". Das Nußknackerlein.\nMit dem er spricht, ist der Henneberger.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Menzingen")]), _vm._v(". Der Henneberger ist auch\nin der Einung?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Löffelholz")]), _vm._v(". Die Henneberger sind in\nder Einung, die Hohenlohe sind in der Einung, die Wertheims und\nviele andre meh.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Rektor Besenmeyer")]), _vm._v(". Was disputieret\ner doch wohl so eifrig?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Der Schultheiß")]), _vm._v(". Kotz Blau, was wird\nes sein!? Die Geschichte vom Bamberger Bischof, mit dem er alleweil\nin Händel gelegen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Martin")]), _vm._v(". Wollt Ihr sie hören, Bruder\nRektor? Ich will sie Euch Wort für Wort aufsagen, und wann Ihr ein\nalt Weib findet im Lande zu Franken, das sie nit herbetet wie das\nPaternoster, so möget Ihr mich lassen mit einem Kürißbengel\ntotschlagen. – Es ist Sag, sie wollen den Berlinger zu eim Obersten\nHauptmann über uns alle setzen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Löffelholz")]), _vm._v(". Das hat Hans Fürzlin\nersonnen. Der Götz ist nit viel meh dann ein hölzern Schüreisen und\nals ein Gefangener im eigenen Haufen. Er darf nit seine Notdurft\nverrichten, es ist einer dabei, der ihm aufpaßt. Was soll er\nausrichten, wenn man ihn wollte zum Herrn machen über\ndreißigtausend wütige Leut?!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Der Schultheiß")]), _vm._v(". Hat kein Marks in\nden Händen, der ganze Götz.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Menzingen")]), _vm._v(". Wo liegt der\nevangelische Hauf, Bruder?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Löffelholz")]), _vm._v(". Zu Hugberg und\nRandersacker. "), _c('a', {
    staticClass: "pcalibre pcalibre1 pcalibre3 pcalibre2",
    attrs: {
      "id": "page23",
      "title": "Teledahner/gary"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Rektor Besenmeyer")]), _vm._v(". Wieviel schätzet\nIhr itzt Bäurische in und um Würzburg?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Der Schultheiß")]), _vm._v(". Potz Leichnam, sie\nkönnten den Main aussaufen!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Menzingen")]), _vm._v(". Meinet Ihr, daß sie sich\nin der Besatzung ernstlich werden zur Wehre schicken und\nunterstehen, das Schloß zu halten wider die Übermacht?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Der Schultheiß")]), _vm._v(". Es ist eine tapfre\nAnzahl guter, gedienter Leut in der Burg.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Löffelholz")]), _vm._v(", "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("zu\nMenzingen.")]), _vm._v(" Mauerbrechend Geschütz, Bruder, als ihr zu\nRothenburg habt; es fehlt uns an guten Stücken; schafft uns eure\nzwo Notschlangen herbei. Ist Bresche gemacht, so lasset Gott und\nden Florian Geyer für das andre sorgen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Martin")]), _vm._v(". Bruder, der Florian Geyer\nverstehet sich auf Kriegshändel meh dann die übrigen Hauptleut samt\nund sunders, und seine Schwarzen richten meh aus dann alle andern\nHaufen der Bauernschaft. Wer den Geyer und seine Schwarzen bei\nWeinsberg gesehn hat, der weiß, daß ich vor Gott red und die lautre\nWahrheit.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Löffelholz")]), _vm._v(". Ich stund auch dabei,\nals sie den Sturm antraten . . . Ihr wißt, daß, inwährend wir mit\ndem Helfensteiner in Handlung stunden, er uns ließ\nhochverräterischerweis seine Reuter im Rücken abbrechen mit Stechen\nund Brennen. Alsbald es ruchbar ward in den Lägern, war jedermanns\nMeinung darauf, daß man sollte mit dem Ernst herfür und stürmen\ngesamter Hand. Zuvor aber waren sie Herolde senden, aber die schoß\nman uns darnieder wider Kriegsbrauch und Recht. Kam einer von den\nGeschickten blutig und mit Geschrei daher, und nu war kein Halten,\nrennete alles wider die Stadtmauer. Itzt trat der Florian Geyer zu\nseinen Schwarzen und schrie sie an: »In einer halben Stunde sind\nwir tot, Brüder, oder die schwarze Fahne steckt uf'm Schloßturm.«\nWas sag ich, Brüder, es sind nit meh dann viertausend Kerls; aber\nwenn sie die Erde über den Kopf geworfen haben und her! her!\nschreien, so wollt ich dem Teufel lieber begegnen. So risch dir\ndrei Rosen am Paternoster durch deine Finger mögen gleiten,\nalsobald brachen sie in die Weinberge, stäubten den Berg hinauf,\nhingen an der Mauer und sprangen darüber wie Katzen, wurfen alles\nnieder und ließen die Bauernfahne von allen Türmen wehn.\n"), _c('span', {
    staticClass: "regie"
  }, [_vm._v("Wilhelm von Grumbach tritt ein,")]), _vm._v(" "), _c('a', {
    staticClass: "pcalibre pcalibre1 pcalibre3 pcalibre2",
    attrs: {
      "id": "page24",
      "title": "suru/gary"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("prachtvoll geharnischt.")]), _vm._v(" Dawider nehmet den\nBerlinger, der will den Fuchs nindert nit beißen. Ihm sind alle\nFuhrten und Gräben zu tief und die Moräste zu breit, den setze der\nTeufel über sich.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Der Schultheiß")]), _vm._v(". Walt's Gott, wir\nerwählen den rechten Mann.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Martin")]), _vm._v(". Hoch Florian Geyer! Sieger\nvon Weinsberg! Der Geyer soll unser Hauptmann sein!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Löffelholz")]), _vm._v(". Sie denken nit alle so\nwie wir.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Wilhelm von Grumbach")]), _vm._v(". Ich wünsch\neuch gute Zeit, ihr Herren!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Löffelholz")]), _vm._v(". Es ist aus und hin mit\nder Herrlichkeit; hie sind keine Herrn. Was willst du, Bruder?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Wilhelm von Grumbach")]), _vm._v(". Des Junkers\nFlorian von Geyer Feldschreiber such ich.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Löffelholz")]), _vm._v(". So wirst du ihn\nebensowenig finden, als wenn du ausgegangen wärst, des Teufels\nFeldschreiber zu suchen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Wilhelm von Grumbach")]), _vm._v(". Kotz Schweiß,\nwo find ich den Lorenz Löffelholz?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Löffelholz")]), _vm._v(". Kotz, ich bin der\nLorenz Löffelholz, aber niemals nit eines Edelmanns Feldschreiber.\nMeinest du, ich sollt sitzen und mich brauchen lassen – Gott weiß\nes, daß ich meh tot dann lebendig bin! –, so es im\nHerrendienst wäre?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Menzingen")]), _vm._v(". Gott grüß dich,\nWilhelm!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Wilhelm von Grumbach")]), _vm._v(". Gott dank\ndir, Stephan!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Menzingen")]), _vm._v(", "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("zu\nLöffelholz")]), _vm._v(". Es ist der Junker von Grumbach, Bruder, dessen\nSchwester der Florian Geyer zur Eh hat.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Löffelholz")]), _vm._v(". Das schiert mich den\nTeufel. Was willst du, Bruder?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Wilhelm von Grumbach")]), _vm._v(". Es ist mir im\nLäger zu Heidingsfeld ein Schutz- und Sicherheitsbrief\nzugesagt.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Löffelholz")]), _vm._v(". Dacht ich's doch\ngleich! Ein armer Ritter, der einen Schutzbrief erbettelt.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Wilhelm von Grumbach")]), _vm._v(", "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("jähzornig")]), _vm._v(". Itzt, Schreiber, gib acht, wer vor dir\nsteht.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Löffelholz")]), _vm._v(". Willst du vom Leder\nzucken!? Ich weiß, daß du ein Wehr hast. Ich weiß auch, wer vor mir\nsteht: ein Bruder Bauer stehet vor mir! Wie heißt du, Bruder?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Wilhelm von Grumbach")]), _vm._v(". Ich bin der\nRitter Wilhelm von Grumbach.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Löffelholz")]), _vm._v(". Streich dein Wappen\naus, Bruder. Es hat kein "), _c('a', {
    staticClass: "pcalibre pcalibre1 pcalibre3 pcalibre2",
    attrs: {
      "id": "page25",
      "title": "suru/gary"
    }
  }), _vm._v(" Art meh damit. Du wirst ein Bauer so gut wie ich,\ndawider kann dir kein Schutzbrief nit helfen. "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("Grumbach nimmt den Schutzbrief, der ihm hingeworfen wird\nwie dem Hunde der Brocken, und unterdrückt seine Wut. Er tritt zu\nMenzingen in eine Nische und redet leise mit ihm.")]), _vm._v(" Ist nichts\ndann Fliehen und Flehen in der Ritterschaft. Denken an nichts\nanders, dann daß sie ihre festen Häuser und Äcker erretten wollen.\nDa sehet den Florian Geyer an, der schonet des Seinen in keinem\nWeg. Haben ihm itzt die Stammburg mit Feuer niedergelegt, hat aber\nnit mit der Wimper gezuckt.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Der Schultheiß")]), _vm._v(", "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("leise zu Löffelholz.")]), _vm._v(" Ich hab gemeint, der Grumbach\nwär in der Besatzung.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Löffelholz")]), _vm._v(". Ei, wär es so, ich\nvergunnt es dem Bischof; es ist nichts gelegen an solcher\nBruderschaft. Es ist ihnen nit ums göttliche Recht. Sie suchen\nihren Vorteil, wie die Raben nach Aas fliegen.")]), _vm._v(" "), _c('p', {
    staticClass: "stage"
  }, [_vm._v("Glocken beginnen zu läuten.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Martin")]), _vm._v(", "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("an der\nTür nach der Kirche.")]), _vm._v(" Brüder, die Kirche ist ganz voll\nMenschen, stehen Kopf an Kopf.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Rektor Besenmeyer")]), _vm._v(". Sagtet Ihr nit,\nder Pater Ambrosius werde predigen?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Der Schultheiß")]), _vm._v(". Ja, Bruder\nRektor!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Rektor Besenmeyer")]), _vm._v(". Es ist wahrlich\nein großer Tag, und nun ich ihn gesehen hab, will ich gern und\ngetrost dahinfahren.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Löffelholz")]), _vm._v(". Mere, liebe Brüder, das\nGlück schneiet mit großen Flocken und ist, Gott! Wunders genug. Es\nist sichtbarlich und mit Händen zu greifen; Gott hat sich in den\nHandel geschlagen und sich der armen teutschen Nation erbarmt.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Rektor Besenmeyer")]), _vm._v(". Es ist Sag: von\nwo unser Herr Jesus ist aufgefahren gen Himmel, im Mittelpunkt der\nErden, da, heißt es, hangt eine große Glocke, die soll einst laut\nund fürchterlich anschlagen, so laut und so fürchterlich soll sie\nanschlagen, daß selbst die Tauben sie hören werden. Wohlan!\nknäufelt die Ohren auf, ihr Tyrannen und Peiniger Leibes und der\nSeele, und merket, daß euer Jüngster Tag nahet.")]), _vm._v(" "), _c('p', {
    staticClass: "stage"
  }, [_vm._v("Bubenleben kommt.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Martin")]), _vm._v(", "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("triumphierend.")]), _vm._v(" Hörst du das Geschrei, Bruder\nBubenleben? Der Florian Geyer reitet ein. "), _c('a', {
    staticClass: "pcalibre pcalibre1 pcalibre3 pcalibre2",
    attrs: {
      "id": "page26",
      "title": "lac/gary"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Löffelholz")]), _vm._v(". Bruder Bubenleben, ich\nverhoff, daß Gott Euch itzt wird die Augen auftun und Euch zeigen,\nwen er sich in diesen Läuften zu seim Helden gemacht.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Bubenleben")]), _vm._v(" "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("legt\neine Druckschrift vor Löffelholz.")]), _vm._v(" Da, leset: An die\nVersammlung der Bauernschaft deutscher Nation, ausgangen von\noberländischen Mitbrüdern. Hie stehet geschrieben die gleiche\nMeinung, uf der ich verharre: die Anführer sollen Bauern sein,\nunsresgleichen. Nimmt man einen von Adel darein, verschleicht man\nWolfshaar unter die Schafwollen. Das kann sich nit reimen, liebe\nBrüder!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Martin")]), _vm._v(", "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("in\nBegeisterungsraserei am Fenster.")]), _vm._v(" Vivat der schwarz\nGeyer!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Rektor Besenmeyer")]), _vm._v(", "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("außer sich.")]), _vm._v(" Vivat St. Georg! Vivat\nSt. Georg!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Löffelholz")]), _vm._v(". Sitzt er nit auf dem\nGaul so richt und strack als ein Bolz?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Rektor Besenmeyer")]), _vm._v(". Wahrlich ein\nechter, rechter Gotteshauptmann!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Der Schultheiß")]), _vm._v(". Hat Rost am\nHarnisch, aber nit am Schwert!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Rektor Besenmeyer")]), _vm._v(". Ein brennendes\nRecht fließt durch sein Herz.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Martin")]), _vm._v(". Vivat der schwarze Geyer!\nVivat Florian Geyer! "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("Er rennt nach der Tür zur\nKirche.")]), _vm._v(" Er ist in die Kirche getreten.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Rektor Besenmeyer")]), _vm._v(". Mit allen\nTrabanten.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Martin")]), _vm._v(". Sind an hundert Trabanten\nmit ihm im vollen Harnisch.")]), _vm._v(" "), _c('p', {
    staticClass: "stage"
  }, [_vm._v("Löffelholz und der Schultheiß flüstern\nmiteinander.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Bubenleben")]), _vm._v(". Da verspür ich wohl\nhöllische Tyrannei, aber nichts nit von christlicher Demut.")]), _vm._v(" "), _c('p', {
    staticClass: "stage"
  }, [_vm._v("Tellermann, geharnischt, kommt herein in einem\nFreudenrausch von Wein- und Einzugsbegeisterung.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Tellermann")]), _vm._v(" "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("steht, schwingt das Schwert hoch.")]), _vm._v(" Grüß euch Gott,\nliebe Brüder, segne euch Gott, liebe evangelische Brüder! Morbleu,\nliebe Brüder. J'ay gaigné mon procès. Entendez-vous? Der große Tag\nist da! Écutez, écutez! Sehet mich nit darauf an, was ich red, wie\nich red. Der Wein ist mir in'n Kopf krochen. Das Glück ist mir ins\nHerz krochen. Brüder, – "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("mit den Fäusten auf den\nTisch trommelnd")]), _vm._v(" – itzt bin ich daheim – und wie sind wir\neingeritten! Mort de ma vie, Pfaff! Itzt sind wir daheim! Wo "), _c('a', {
    staticClass: "pcalibre pcalibre1 pcalibre3 pcalibre2",
    attrs: {
      "id": "page27",
      "title": "suru/gary"
    }
  }), _vm._v(" aber bist du,\nBischöflein? Hast davongemußt, dich flüchten aus deinem Pracht.\nBugre! larron! menteur! fils de putain! traître! faquin! brutal!\nbourreau! Hast uns verjagt und vertrieben wie schlechte Hunde.\nOutrage pour outrage!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Der Schultheiß")]), _vm._v(". Wie sieht's aus uf\nder Gassen, Bruder?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Tellermann")]), _vm._v(", "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("den\nSchultheiß umarmend.")]), _vm._v(" Brüderlein, liebes Schultheißlein, es\nist meh des Segens, dann einer kann im Busen behalten. Gott, Gott!\nWas eine glückselige Widerfahrt! Je Jene, je Jene. Juch! Der\nFlorian Geyer soll leben! Oberster Feldhauptmann über alle Haufen.\nEin Hundsfott, der nit Bescheid tut!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Der Schultheiß")]), _vm._v(". Walt's Gott! Ich tu\ndir Bescheid!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Tellermann")]), _vm._v(". Morbleu! Wie haben sie\nihn geehrt! Am Hauger Tor hat er still gehalten. Ist wie alle Tore\nsperrangelweit ufgewest. Hat aber dannoch dawider gebocht mit dem\nSchwertknauf und hinaufgeschrien gen den Frauenberg. »Hie kehre ich\nheim, Florian Geyer, in Kaisers Acht und Papstes Bann, aber von\nGott erweckt, erwählet und geführet! Hie kehre ich heim, Florian\nGeyer, des Sickingen Freund und der Pfaffen Feind, wie ich bei mir\nselbst gelobt und geschworen, und will nit rasten, bis daß ich dein\nhochstolz Schloß, du hochstolzer, teuflischer Pfaffe Konrad, in\nGrund verstört.« So hat er geschrien, so sind wir einritten. War\ndes Jubeljauchzens kein Ende; wehten mit Tüchern aus allen\nFenstern. Die Weiber wollten gar auf die Straßen springen vor\nJauchzen und Lust; sein Gaul konnte kaum fortschreiten. Sie küßten\nihm den Stegreif und leckten ihm den Rost vom Harnisch. Waren\ndieselben Plätze und Straßen, wo römisch-kaiserliche Majestät offne\nAcht über uns ausblasen, verrufen und ausschreien lassen.\n"), _c('span', {
    staticClass: "regie"
  }, [_vm._v("Mit Beziehung auf Bubenleben.")]), _vm._v(" Was will\nder Pfaff hier? Alle in einen Sack und unter die Schindbrücke mit\nihnen!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Der Schultheiß")]), _vm._v(". Sei ruhig, Bruder,\nfasse dich, Bruder!")]), _vm._v(" "), _c('p', {
    staticClass: "stage"
  }, [_vm._v("Ein Domherr, der Schreiberdienste tut, kommt.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Tellermann")]), _vm._v(". Kotz Blut, kenn ich\ndich nit, bist du nit ein verfluchter Domherr vordem gewest? Mort\nde ma vie! Hat nit der Sendpfaff mit dir zu Morgen gessen, nachdem\ner den Stab gebrochen über meine Mutter selig?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Domherr")]), _vm._v(". Ach Lieber, mein Herr, Ihr\nirret Euch wahrlich!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Tellermann")]), _vm._v(". Hast du nit Scheiter\nherbeigeschleppt und Öl, Pech und Schwefel daraufgossen, als man\nsie verbrannt "), _c('a', {
    staticClass: "pcalibre pcalibre1 pcalibre3 pcalibre2",
    attrs: {
      "id": "page28",
      "title": "suru/gary"
    }
  }), _vm._v("\nauf dem Jüdenplatz? Da, hier, schau mich an! Ich bin der\nTellermann, ich bin ein Begard, ich bin ein Kunde, ich bin ein\nheimlicher Ketzer. Meine Mutter selig wollt's nit gestehn, man hat\nsie aufgezogen eine Hand hoch, so lang man drei Paternoster\nspricht. Sie hat's nit gestanden, Gott verzeih ihr's. Ich aber\nbekenn freiwillig: ich hab allezeit das Evangelium liebgehabt, meh\ndann Menschentand. Ich leugne nit: ich gehör zu den freien\nGeistern. Frei sind wir, weil Gott uns befreit hat und unsre\nBedrücker, Feinde und Seelenmörder zerstreuet wie Mehl. Frei sind\nwir, weil wir kein Gewissen nit haben und von diesem bösen Tier nit\nzerfetzet und zerrissen werden. Und, Pfaffe, so hindert mich\nnichts, daß ich dich niederschlag . . .")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Der Schultheiß")]), _vm._v(". Friede! Friede!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Tellermann")]), _vm._v(", "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("vom\nSchultheiß und den andern gehalten und verhindert, in Raserei,\nschreit.")]), _vm._v(" Schlagt tot! Schlagt tot! "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("Der\nDomherr flüchtet sich, und Tellermann sinkt, erschöpft und nahezu\nbesinnungslos, auf einen Stuhl.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Der Schultheiß")]), _vm._v(". Es ist der\nTellermann, eines Roßhändlers Sohn. Haben ihm vor zehn Jahren hie\nzu Würzburg die Mutter verbrannt. Da hat es ihn itzunder übermannt,\nansonsten kein besserer Kriegsmann im ganzen hellen Haufen dann er.\nDer Geyer und er sind eine Hand.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Rektor Besenmeyer")]), _vm._v(". Ein rasender\nAjax, Brüder!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Der Schultheiß")]), _vm._v(". Hunderte für einen\nallenthalben im Volk!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Rektor Besenmeyer")]), _vm._v(".\nGottesgeißeln!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Der Schultheiß")]), _vm._v(". Saat von\nDrachenzähnen, ausgesäet von Papst, Kardinälen, Bischöfen und\nMeßpfaffen, aufgangen ihnen selbst zum Verderben.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Rektor Besenmeyer")]), _vm._v(". Schweig stille,\nder Pater Ambrosius spricht! "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("Man hört aus der\nKirche den Tonfall einer Predigt, ohne Worte zu\nverstehen.")])]), _vm._v(" "), _c('p', {
    staticClass: "stage"
  }, [_vm._v("Durch die Nebentür links treten auf Sebastian von\nRotenhahn, Wolf von Kastell, Hans von Lichtenstein, Hans von\nGrumbach, Kunz von der Mühlen. Sie werden geführt von\nSartorius.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Sartorius")]), _vm._v(", "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("mit\nGravität zu Löffelholz tretend, der, im Anhören der Predigt\nbegriffen, sein Herankommen nicht bemerkt hat.")]), _vm._v(" Ihr werdet\nmir verzeihen . . . Ich habe die Legation hergeführt, Euer\nHochgelahrt.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Löffelholz")]), _vm._v(". Zu früh, Bruder.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Sartorius")]), _vm._v(". Ich bin von Wendel\nHipplern auf diese Stunde befohlen, Euer Hochgelahrt. "), _c('a', {
    staticClass: "pcalibre pcalibre1 pcalibre3 pcalibre2",
    attrs: {
      "id": "page29",
      "title": "r_a_5/quilter"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Löffelholz")]), _vm._v(". Ei, nennet mich doch\nnicht Hochgelahrt, Bruder. Wir sind allzumal Sünder und mangeln des\nRuhms.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Sartorius")]), _vm._v(". Mere, lieber Bruder, Ihr\nhabt recht.")]), _vm._v(" "), _c('p', {
    staticClass: "stage"
  }, [_vm._v("Sie fahren fort, leise miteinander zu sprechen.\nDerweil hat die Gruppe der Gesandtschaft untereinander geflüstert.\nWilhelm von Grumbach hat eine Wendung gemacht und sie bemerkt. Er\nstößt Menzingen an, und beide blicken sich um. Möglichst\nunauffällig treten beide der Gesandtschaftsgruppe näher.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Sebastian von Rotenhahn")]), _vm._v(",\n"), _c('span', {
    staticClass: "regie"
  }, [_vm._v("gepreßt")]), _vm._v(". Bei der Liebe Gottes! seid ihr\nzu schwarzen Bauern worden?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Wilhelm von Grumbach")]), _vm._v(". Ich bin in\ndes Markgrafen zu Ansbach Diensten hie.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Sebastian von Rotenhahn")]), _vm._v(". Hast aber\ndoch das bäurische Kreuz am Arm.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Wilhelm von Grumbach")]), _vm._v(". Muß wohl, es\nsei mir lieb oder leid. Ist ohn das nit durchzukommen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Sebastian von Rotenhahn")]), _vm._v(". Junker von\nMenzingen? Wo hat Euch der Teufel hergetragen?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Menzingen")]), _vm._v(". Ich bin in der Legation\nvon Rothenburg.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Sebastian von Rotenhahn")]), _vm._v(". Seid Ihr\ndann zu Rothenburg Bürger worden?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Menzingen")]), _vm._v(". Ei freilich, Junker!\nWußtet Ihr das noch nit?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Sebastian von Rotenhahn")]), _vm._v(". Wußt ich\nes schon nit, so begreif ich es dennoch zu wohl, daß Ihr hinter den\nMauern der Reichsstädte Schutz suchet.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Menzingen")]), _vm._v(". Ihr beliebet zu\nscherzen, Ritter!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Sebastian von Rotenhahn")]), _vm._v(". Hat nicht\nEuer Name auch unter der Absag gestanden, die der Landes\nVertriebene Ulrich von Württemberg gen Stuttgart getan, bevor ihn\nder Helfensteiner so böslich und meisterlich hat heimgehen\nheißen?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Menzingen")]), _vm._v(". Der Handel ist nit zu\nEnde, Ritter! Ist darnach dem Helfensteiner übel bekommen. Hat\nmüssen zu Weinsberg sein Leben lassen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Sebastian von Rotenhahn")]), _vm._v(". Je, saget\nIhr das!? – So spricht dann die Red wahr, die unter dem Volke\ngehet: der König von Frankreich und der verlorne Fürst hätten die\nKarten gemischt, der Geyer hätt sie zu Hohentwiel vom Tische\ngenommen und ausgeben: und also das große bäurische Spiel\nangehoben!?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Menzingen")]), _vm._v(". Da fraget Ihr nach!?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Sebastian von Rotenhahn")]), _vm._v(". So wird\nman ein jedes Tröpflein "), _c('a', {
    staticClass: "pcalibre pcalibre1 pcalibre3 pcalibre2",
    attrs: {
      "id": "page30",
      "title": "r_a_5/gary"
    }
  }), _vm._v(" adligen Bluts, zu Weinsberg vergossen, dereinst\nvon Euch fordern. "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("Menzingen wendet sich mit\nAchselzucken.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Lichtenstein")]), _vm._v(". Will die hochstolze\nreichsfreie Stadt sich auch mit dem Unrat vermengen und sich in die\nhöllische Einung tun?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Menzingen")]), _vm._v(". Das wird geschehen, wie\nGott es fügt, Ritter.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Hans von Grumbach")]), _vm._v(", "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("zu Wilhelm")]), _vm._v(". Kotz Leichnam, Vetter, sollen wir einer\ndem andern Feind sein? Wie reimet sich das?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Wilhelm von Grumbach")]), _vm._v(". Blau, Hans!\nDa siehe du zu!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Wolf von Kastell")]), _vm._v(". Hat dich der\nBischof nit ufgemahnet, dich in die Besatzung zu tun?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Wilhelm von Grumbach")]), _vm._v(". Ich bin dem\nMarkgrafen zu Ansbach mit Diensten verbunden und für ihn zu reiten\nund reisen verpflicht.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Lichtenstein")]), _vm._v(". Der Junker von\nGrumbach hat es niemalen anders gehalten: wann er die Klepper im\nDienste des Markgrafen abgetrieben, so stunden sie bald danach am\nHof unsers Bischofs in Habern bis an den Hals.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Wilhelm von Grumbach")]), _vm._v(". Kotz Bauch,\ndafür hab ich nit meh dann fünfhundert Schweine im Gramschatz und\nder Bischof ihrer zweitausend auf Eichelmast, und ist doch mein\nWald. Dafür schießen seine Domherrn und Diener das Wild in meinem\nForst und fischen in meinen Bächen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Wolf von Kastell")]), _vm._v(". Bist du unbillig\nbeschweret, so hast du den Weg Rechtens.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Wilhelm von Grumbach")]), _vm._v(". Die Pfaffen\ntun mit Liebe nichts, man ziehe ihnen dann das Fell über die\nOhren.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Wolf von Kastell")]), _vm._v(". Bist du nit\nschuldig, dem Bischof zuzuziehn?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Wilhelm von Grumbach")]), _vm._v(". Leichnam! So\nhat der Pfaff wahrlich gut Riemen schneiden, wenn die reichsfreie\nRitterschaft ihre Haut also billig und knechtswillig zu Markte\nbringt. Ich bin nit schuldig, dem Bischof in eigner Person\nzuzuziehn! ist wider Herkommen fränkischen Adels.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Hans von Grumbach")]), _vm._v(". Hast du nit\ndeine Güter vom Stift zu Lehen?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Wilhelm von Grumbach")]), _vm._v(". Unsere Lehne\nsind nit Gnaden- und Dienstlehne, sondern freie Lehne.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Wolf von Kastell,")]), _vm._v(" "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("zu Sartorius, der herantritt.")]), _vm._v(" Ist wohl Eure\nWeisheit, Herr Magister?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Sartorius")]), _vm._v(". Ich fürchte Gott und\nliebe meinen Herrn, Euer "), _c('a', {
    staticClass: "pcalibre pcalibre1 pcalibre3 pcalibre2",
    attrs: {
      "id": "page31",
      "title": "r_a_5/gary"
    }
  }), _vm._v(" Edel. Ich diene Seiner Gestrengen mit meinem\nPaternoster und guten Rat, solange es Gott und meinem gnädigen\nHerrn gefällt.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Wilhelm von Grumbach")]), _vm._v(". Brav gered't,\nMeister!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Wolf von Kastell")]), _vm._v(". Die Juristen und\nRäte, das ist die Pest; treiben ihre Herren in Unrat und Verderben.\nHole der Teufel alle roten Schuhe!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Menzingen")]), _vm._v(". So seht doch zuallererst\neuren Bischof an! Der ist mit Juristen behängt wie ein Jakobsbruder\nmit Muscheln.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Sebastian von Rotenhahn")]), _vm._v(",\n"), _c('span', {
    staticClass: "regie"
  }, [_vm._v("zu Sartorius")]), _vm._v(". Das Üble bei dem Handel\nist: Ihr kommet um Eure Verehrung, Magister.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Sartorius")]), _vm._v(". Das soll mich nit\nkränken, Euer Hochgelahrt!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Sebastian von Rotenhahn")]), _vm._v(". Entlaufet\nIhr schon des Bischofs Nachrichter, so zieht man Euch desto\nsicherer an dem bäurischen Galgen auf.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Sartorius")]), _vm._v(". Steht zu bedenken, Euer\nEdlen. Ich tue das Gute nit um schnöder Handsalben willen, Euer\nHochgelahrt; und vermeide das Rechte nit aus niederer Furcht.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Lichtenstein")]), _vm._v(". Das Kurze und Lange\nist: der Junker von Grumbach verrät seinen Lehnsherrn.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Wilhelm von Grumbach")]), _vm._v(". Der Kaiser\nist mein Lehnsherr und kein Pfaffe zu Würzburg; ich bin kein\nPfaffenknecht.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Sebastian von Rotenhahn")]), _vm._v(". Das ist\nitzt der Ton, danach alle singen. Wer itzt das Rechte will und das\nGute tut, der heißt ein Pfaffenknecht.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Wilhelm von Grumbach")]), _vm._v(". Kotz Dreck,\nitzt auf einmal, itzt war ich dem Bischof gut genung, itzt soll ich\nihm seine Schmalzgruben und den Domherren ihre seidenen Betten und\nihren Wollust verteidigen. Das tue der Teufel!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Löffelholz")]), _vm._v(". Was reden die Ritter\nuntereinander?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Sartorius")]), _vm._v(". Ihr Herren, tretet\nzurück, folget mir! Wir sind zu früh kommen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Wolf von Kastell")]), _vm._v(". Kotz Blau, ich\nmöcht mit der Wehre dreinschlagen.")]), _vm._v(" "), _c('p', {
    staticClass: "stage"
  }, [_vm._v("Von Sartorius geleitet, ziehen sie sich\nzurück.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Rektor Besenmeyer")]), _vm._v(", "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("immer noch der Predigt zuhörend")]), _vm._v(". Der Pater Ambrosius\nschließt die Predigt in Latein. Er weiset die Brüder und Schwestern\nauf Wiclefs evangelischen Zukunftsstaat. Tunc necessitaretur\nrespublica redire ad politiam evangelicam, habens omnia in\ncommuni . . . Brav, Bruder, in deiner Predigt war Gottestreiben. Du\nhast "), _c('a', {
    staticClass: "pcalibre pcalibre1 pcalibre3 pcalibre2",
    attrs: {
      "id": "page32",
      "title": "r_a_5/gary"
    }
  }), _vm._v(" wahrlich\nnit von blauen Enten und von Hühnermilch gered't! War ein ander\nDing als damalen, zu Erfurt in der Burs, als ich Kollegiat war und\ntäglich eine Rede über die Jungfrau hinunterschlucken mußte.")]), _vm._v(" "), _c('p', {
    staticClass: "stage"
  }, [_vm._v("Die Gemeine singt in der Kirche. Zu Beginn des\nGesanges ist Tellermann auf beide Füße gesprungen. Regellos und\ngruppenweise betreten jetzt bäurische Hauptleute und Räte von der\nKirche aus die Kapitelstube. Sie flüstern und reden lebhaft\nmiteinander, ohne daß man etwas versteht. Die Ritter werden bemerkt\nund mißtrauisch betrachtet. Unter den Hereingekommenen ist Wendel\nHippler, welcher sogleich lebhaft mit Löffelholz disputiert und\ngestikuliert. Er wird von den meisten äußerst respektvoll\nbehandelt. Sartorius, wieder hereingekommen, bemüht sich\nehrfurchtsvoll um ihn. Der dicke Jacob Kohl ist auch zugegen. Er\nist sogleich mit Bubenleben ins Gespräch geraten. Man erkennt, wie\nsie unzufrieden, ja über irgend etwas entrüstet sind. Eine\ngelbschwarze Fahne und eine weiß-damastene werden hereingetragen;\nauf der einen ist mit Goldfäden eine Sonne und ein Bundschuh\ngestickt, dazu die Inschrift: »Wer da frei will sein, der zieh in\ndiesen Sonnenschein.« Götz von Berlichingen, der kaum andere als\nhämische Beachtung findet, tritt ein im Gespräch mit Georg Metzler.\nSie nähern sich Hippler und bilden im Verein mit diesem und\nSartorius eine Gruppe. Götz erscheint unwirsch und ablehnend.\nWilhelm von Grumbach gliedert sich an diese Gruppe und begrüßt sich\nmit Götz und dem Grafen Georg von Wertheim, der sich auch\nangefunden hat. Flammenbecker, ein Weinsberger, gestikuliert wild\nunter Genossen. Link, ein Würzburger Bürger, hat auch eine kleine\nGemeine um sich gebildet. In der Gesamtheit verrät sich bei allem\nHochgefühl eine Besorgnis, Erregung, ja Spannung.")]), _vm._v(" "), _c('p', {
    staticClass: "stage"
  }, [_vm._v("Florian Geyer, schwarz geharnischt, schwarze\nStraußenfedern auf dem Helme, kommt, ein großes Gefolge hinter\nsich. Zwei schwarze Fahnen werden hinter ihm dreingetragen. Mit\nGeyers Eintritt schweigt der Gesang in der Kirche, die Glocken\nschweigen, und in der Kapitelstube wird es plötzlich totenstill.\nKonrad von Hanstein ist an Geyers Seite eingetreten.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Florian Geyer")]), _vm._v(", "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("zu Hanstein")]), _vm._v(". Das alte Kaiserrecht bestätigt es uns.\nDie Gemeinfreien haben Konföderationsrecht. Wir sind freie Franken,\nund überdas: haben die Fürsten nit die Kreiseinung, haben sie nit\nden Bund zu Regensburg gestiftet wider die evangelische Lehre?\nEinung wider Einung! "), _c('a', {
    staticClass: "pcalibre pcalibre1 pcalibre3 pcalibre2",
    attrs: {
      "id": "page33",
      "title": "r_a_5/lac"
    }
  }), _vm._v(" Die Fürsten wollen's nit gelten lassen; das machen\ndie verfluchten Barettlinsleut und römischen Juristen. Ich glaube,\ndaß kein Tyrann jemalen hat so viel Schaden gestift't als\nJustinian. Das fremde, ausländische Recht ist über uns kommen\ngleich einer Sintfluß. Ich lobe mir unser deutsches Herkommen, die\nfreien Ringe statt der Amtsstuben.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Rektor Besenmeyer")]), _vm._v(", "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("ergriffen und ehrfurchtsvoll.")]), _vm._v(" Kennet Ihr mich noch,\nBruder Geyer?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Florian Geyer")]), _vm._v(". Potz Zäpfel, Euch\nsollt ich nit kennen, Rektor Besenmeyer? Hab ich nit gemustert in\nEurer Landwehr? Haben wir nit in Philipp Tuchscheerers Haus zu\nRothenburg die Beine unter den gleichen Tisch gestellet? Was macht\nder Karlstatt?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Rektor Besenmeyer")]), _vm._v(". Er will je eher,\nje lieber zu Euch ins Läger kommen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Florian Geyer")]), _vm._v(". Das verhüte Gott!\nIhr wollt ihm wohl und der Sachen wohl, so machet, daß er von\nseinem Vorsatz absteht. Wir haben Prädikanten meh dann zu viel in\nden Lägern. Die Glaubenssachen und himmlischen Dinge soll man\neinstweilen dahinten lassen, keine Theologie in Kriegshandwerk\nmengen und sich der irdischen Dinge allein befleißen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Bubenleben")]), _vm._v(", "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("zu\nKohl.")]), _vm._v(" Ei, was eine bübische, höllische Weisheit! Er hat,\nSt. Velten, den Schulsack gefressen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Kohl")]), _vm._v(". Sehet den Rektor an, wie er\ngramanzet und ihm die Hand küsset.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Bubenleben")]), _vm._v(". Lieber, ich kenne den\nstinkigen Bacchanten allzuwohl. Sein Gott ist der Aristoteles; der\nCicero, Vergil und Livius seine Heiligen. Eine gute Latinität gilt\nihm meh denn das ganze Christentum.")]), _vm._v(" "), _c('p', {
    staticClass: "stage"
  }, [_vm._v("Besenmeyer hat, von Rührung übermannt, Geyers Hand\ngeküßt.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Florian Geyer")]), _vm._v(". Was machet Ihr doch,\nlieber Vater! Das will ich Euch tun. Ich bin ein grober und\nungelehrter Kopf. Und hat doch selbst der herrliche,\ndurchlauchtigste Kaiser Max gesagt: die Gelehrten seien es, die da\nregieren und nit untertan sein sollten und denen man die meiste\nEhre schuldig war, weil Gott und die Natur sie uns anderen\nvorgezogen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Rektor Besenmeyer")]), _vm._v(". Lasset es zu,\nBruder! Es tut meiner armen Seele wohl. Denket Ihr noch daran, wie\nwir miteinander das Symposion hatten, damalen, zu Gotha, bei dem\nMutian? Ihr hattet den Ulrich von Hutten zur Rechten "), _c('a', {
    staticClass: "pcalibre pcalibre1 pcalibre3 pcalibre2",
    attrs: {
      "id": "page34",
      "title": "joe_ebc/lac"
    }
  }), _vm._v(" und mich zur Linken sitzen.\nDer Eitelfritz von Zollern saß uns gegenüber.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Florian Geyer")]), _vm._v(". Ich weiß es\nwohl.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Rektor Besenmeyer")]), _vm._v(", "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("mit verhaltener Begeisterung.")]), _vm._v(" Wißt Ihr auch wohl,\nwie Ihr dazumalen aufstundet, den Kranz aus dem Haar nahmet und\nausriefet: »Es ist zu früh, sich mit Rosen bekränzen, dieweil noch\nder Antichrist zu Rom sich mästet von unserm Mark, der deutsche\nKaiser nach Brot betteln muß, das Recht um Geld feil ist, der Ewige\nLandfriede auf dem Papier stehet und das Evangelium unterdrücket\nist.« Wo stunden wir damalen, und wo stehen wir itzt?!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Geyer")]), _vm._v(", "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("froh.")]), _vm._v(" Die Glocke ist gar gegossen, und der Pfeifer\nmag aufpfeifen: das wollen wir Gott im Himmel danken!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Martin")]), _vm._v(", "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("begeistert.")]), _vm._v(" Das danken wir Gott und dem Florian\nGeyer.")]), _vm._v(" "), _c('p', {
    staticClass: "stage"
  }, [_vm._v("Geyer nimmt am oberen Ende des Tisches Platz;\nhinter ihm stellen sich auf Tellermann und der Schultheiß, rechts\nneben ihn setzt sich Hippler, links Löffelholz, hinter diesem steht\nMartin, gewärtig seines Winkes. Hippler rückt für Sartorius neben\nsich einen Stuhl zurecht. Sartorius setzt sich mit vielen demütigen\nReverenzen. Hanstein ist mit Grumbach und Menzingen ins Gespräch\ngekommen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Löffelholz")]), _vm._v(", "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("aufstehend.")]), _vm._v(" Brüder, Hauptleute und Räte! Nehmet\nPlatz! Es ist vieles zu bewegen, beraten und zu beschließen. Nehmet\nPlatz, liebe evangelische Brüder! Nehmet Platz!")]), _vm._v(" "), _c('p', {
    staticClass: "stage"
  }, [_vm._v("Götz von Berlichingen setzt sich zugleich mit\nGeorg von Wertheim, dem Grafen von Henneberg, Georg Metzler und\nanderen nieder. Herolde blasen eine Fanfare.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Geyer")]), _vm._v(", "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("nach\nSchluß der Fanfare sich erhebend.")]), _vm._v(" Der Versammlungsrat aller\nHaufen gemeiner Bauernschaft in und um Würzburg ist hiemit\neröffnet.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Löffelholz")]), _vm._v(". Fast viel Arbeit,\nBrüder! Viel zu bewegen und beschließen. Es sind Boten und Posten\nherein von Hohenlohe, Nürnberg, aus vielen Orten der Oberpfalz, von\nBamberg, von Mainz, von Straßburg; aus dem Läger des Truchsessen\nvon Waldburg haben wir Kundschaft, aus dem Elsaß, aus dem Tirol,\naus dem Salzburgischen, von Thomas Münzer aus Thüringen und anderen\nLeuten und Orten meh. Erheischet alles ein Antwort. Es mangelt an\nSchreibern in der Kanzlei, hab aber dannoch niemalen meh Freud an\nder "), _c('a', {
    staticClass: "pcalibre pcalibre1 pcalibre3 pcalibre2",
    attrs: {
      "id": "page35",
      "title": "joe_ebc/lac"
    }
  }), _vm._v(" Feder\ngehabt. Der Markgraf Kasimir hat Boten von Ansbach gesandt, und hie\nist die Kredenz – warten in der Sakristei. Rothenburg ob der Tauber\nhat eine Legation abgefertigt – wartet in der Sakristei.\nBeschließlich erheischet die Gesandtschaft ein Bescheid, die der\nMarkgraf Dompropst von Unserer Frauen Berg gütlicher Handlung\nwillen an die Versammlung gemeiner Bauernschaft abgeordnet – wartet\nin der Sakristei. Es ist meine Meinung, Brüder, daß wir uns diese\nzuerst anliegen lassen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Flammenbecker")]), _vm._v(", "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("unwirsch hingeflegelt.")]), _vm._v(" Man soll auf nichts eingehen,\ndie Besatzung übergebe dann das Schloß mit allem, was darin\nist.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Bubenleben")]), _vm._v(", "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("beiläufig.")]), _vm._v(" Ich sag ja und amen dazu, und mag die\nBesatzung abziehen unter Versicherung Leibes und Lebens.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Götz")]), _vm._v(", "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("halb für\nsich, halb für die andern.")]), _vm._v(" Was will man meh, dann wozu sich\ndie Besatzung uf Unserer Frauen Berg gütlich erboten hat? Sie\nwollen die Zwölf Artikel annehmen mit handgebenden Treuen und\nunsere evangelischen Brüder sein.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Flammenbecker")]), _vm._v(". Faule Possen, potz\nLung!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Bubenleben")]), _vm._v(". Eine Krähe hacket der\nandern die Augen nit aus. Man soll keinem Ritter in dieser Sache\ntrauen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Link")]), _vm._v(". Ein Grindiger krauet den\nandern gar sanft. Der Bruder Berlinger hat gute Gesellen und Freund\nin der Burg, da liegt der Hase im Pfeffer, Brüder!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Götz")]), _vm._v(". Man soll nit vor festen\nSchlössern verliegen. Es tut not, von Statt rucken.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Bubenleben")]), _vm._v(". Es liegt ihm hart an,\ndaß wir je eher je lieber auf und wider seinen alten Feind, den\nBamberger, ziehen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Geyer")]), _vm._v(". Der Bruder Berlinger hat\nwahr, ich kann's nit unbilligen. Wollen sie in der Besatzung auf\ndie Artikel geloben und schwören, blau! so lasse man sich benügen.\nEs mangelt uns vorhero mauerbrechend Geschütz; ohn das ist nichts\nzu verrichten, der Feste nichts abzubrechen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Link")]), _vm._v(". Brüder! ich bin ein\nWürzburger; die Würzburger aber sind eines Kopfs: das Schloß muß\nherunter. Du sagst von Geschütz, Bruder Geyer! Da steht der Bruder\nvon Wertheim, hat uns Geschütz zugesagt, und damit gedenken wir, ob\nGott will, schnelle Arbeit zu tun! Soll denen in der Besatzung der\nReif am Kübel dermaßen werden angezogen, daß sie wie Fische sollen\ndaraus springen, auf Gnad und "), _c('a', {
    staticClass: "pcalibre pcalibre1 pcalibre3 pcalibre2",
    attrs: {
      "id": "page36",
      "title": "joe_ebc/lac"
    }
  }), _vm._v(" Ungnad sich uns ergeben. Zöget ihr aber itzt\nungestürmter Weis gen Bamberg oder Ansbach, so haben wir\nSchlimmeres zu Würzburg von den Bischöflichen zu befahren als\nvordem jemalen erhört ist worden.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Hippler")]), _vm._v(". So laßt uns ein mehrers\nmachen. Wessen Meinung daruf gestellt ist, daß man uf das Erbieten\nder Besatzung eingehe, der hebe die Hand. "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("Götz,\nGeyer, Hippler, Tellermann, Metzler, Löffelholz, Sartorius,\nWertheim und Henneberg usw. heben die Hand. Es ist eine kleine\nMinderheit.")]), _vm._v(" Jetzunder die Gegenprob! "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("Die\ngroße Mehrheit erhebt die Hände.")])]), _vm._v(" "), _c('p', {
    staticClass: "stage"
  }, [_vm._v("Sartorius, durch Hippler veranlaßt, steht auf,\nbegibt sich hinaus und kehrt mit der Gesandtschaft wieder:\nSebastian von Rotenhahn, Wolf von Kastell, Hans von Lichtenstein,\nKunz von der Mühlen treten ein. Es wird still, die Bauernhauptleute\nflegeln sich herum und gebärden sich hochfahrend und verächtlich\nnach Möglichkeit.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Hippler")]), _vm._v(", "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("sitzend zu der stehenden Gesandtschaft.")]), _vm._v(" Der\nVersammlungsrat gemeiner Bauernschaft stellt an euch das Verlangen,\ndas Schloß Unsrer Frauen Berg und alle darin begriffene feste und\nfahrende Hab zu übergeben, gegen Versicherung für euch, eure Diener\nund Knecht, mit Geleit hinwegzuziehen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Sebastian von Rotenhahn")]), _vm._v(",\n"), _c('span', {
    staticClass: "regie"
  }, [_vm._v("nach einigem Nachdenken.")]), _vm._v(" Das zuzusagen\nhaben wir keine Vollmacht. Aber wir wollen geloben, euer Erfordern\nbei eilender Post unserem gnädigen Herrn und Bischof in sein\nGewahrsam zu überschicken.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Link")]), _vm._v(". So sperret man uns die Mäuler\nuf mit Tagsatzen, Gesandtschaften hin und wider reisen und allen\nverfluchten, welschen, hinterhältigen Praktiken, und zielen auf\nnichts, dann daß sie uns ufhalten und Zeit und Weile zum Widerstand\ngewinnen. Man wird euch den Ernst merken lassen und euch den Ave\nMaria mit Stückkugeln in die Burg schicken!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Götz")]), _vm._v(". Ist die Bauernschaft willens,\nhie zu Würzburg ein so grausam und gottverflucht Stücklein zu\nspielen, als es jüngst zu Weinsberg zu unwiederbringlicher Schmach\nund Schaden gemeinen bäurischen Handels beschehen ist, so hab ich\nnichts mit gemein. "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("Aufregung.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Bubenleben")]), _vm._v(". Ich frage euch hie,\nBruder Götz, und dich, Bruder Metzler: hat der Markgraf Dompropst\neuch Geld geboten für den Abzug oder nit? – Gehet rund durch mit\n"), _c('a', {
    staticClass: "pcalibre pcalibre1 pcalibre3 pcalibre2",
    attrs: {
      "id": "page37",
      "title": "joe_ebc/lac"
    }
  }), _vm._v(" der Antwort!\n– – Es ist Sag: die Besatzung hätt sich wollen allein euch\nzugeloben, und sollte dafür den Hauptleuten des Haufens dreitausend\nGulden Schätzung gezahlt und jedem Knecht ein halber Monatssold\nzugestellt werden.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Götz")]), _vm._v(". Hauptleut und Rät des\nOdenwälder Heers sind nit gehalten, ichtwem Red und Antwort zu\nstehen als ganzer Gemeine des eigenen Haufs! "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("Aufregung.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Link")]), _vm._v(". Pfei der Schand!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Flammenbecker")]), _vm._v(". Verdammter Finanzer!\nNieder mit ihm!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Link")]), _vm._v(". Auf den Schindacker mit dem\nGötz!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Geyer")]), _vm._v(" "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("springt\nauf.")]), _vm._v(" Brüder, sind wir Leute, die Händel uf Gewinn treiben,\noder haben wir zusammen geschworen, dem Evangelium und Gottes Wort\nbeiständig zu sein? Sind wir Gutgewinner und Beutelschneider oder\nfreie deutsche Männer und Christenleut, die ihr Vornehmen daruf\ngericht't haben, daß Fried, Freiheit, Einigkeit, Sicherheit Handels\nund Wandels in deutscher Nation anhebe und aufrecht bleibe? –\n"), _c('span', {
    staticClass: "regie"
  }, [_vm._v("Zur Gesandtschaft.")]), _vm._v(" Der Markgraf\nDompropst bietet Geld für den Abzug. Will er uns die Ehre abkaufen?\nIhr Herren, auf! und bringet ihm diesen Bescheid: der Papst\nverschachert Christum, die deutschen Fürsten verschachern die\ndeutsche Kaiserkrone, aber die deutschen Bauern verschachern die\nevangelische Freiheit nit! "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("Zustimmung.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Sebastian von Rotenhahn")]), _vm._v(". Die\nevangelische Freiheit hat bessere Diener, als Ihr einer seid.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Geyer")]), _vm._v(". Das gebe Gott, und das wolle\nGott! Ihr aber seid ganz verrömert und Pfaffenknecht. Der Ulrich\nvon Hutten war ein besserer als ich; er hat Euch die Trias Romana\ngewidmet, Ihr wart's nit wert.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Sebastian von Rotenhahn")]), _vm._v(". Ich setze\nmich nit wider Kaiser und Reich.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Geyer")]), _vm._v(". Wir tun es auch nit,\nniemalen und in keinem Weg. Unser Fürnehmen stehet allein darauf,\ndem Kaiser seine alte Macht wiederzugeben, unverkümmert von Pfaffen\nund Fürsten. Ihr setzet euch wider den Kaiser, die ihr Pfaffen und\nFürsten beiständig seid. Was hat doch der edle Kaiser Max gesagt:\nPfaffen und Fürsten hätten ihn zu Worms gebunden und an einen Nagel\ngehenket. Taten von Pfaffen und Fürsten für Kaiser und Reich?\nTrauben von den Disteln. Wenn der Kaiser die Läufte verstünd: hie\nsind seine Bundsgenossen. "), _c('a', {
    staticClass: "pcalibre pcalibre1 pcalibre3 pcalibre2",
    attrs: {
      "id": "page38",
      "title": "joe_ebc/lac"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Sebastian von Rotenhahn")]), _vm._v(". Kotz Blut!\nWas eine Schmachbürden richtet Ihr Euch zu, Ihr, ehmals ein\nehrlicher Ritter von Adel.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Geyer")]), _vm._v(", "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("den Helm\nabnehmend und seinen geschorenen Kopf zeigend.")]), _vm._v(" Ein Bauer bin\nich und nichts dann ein Bauer!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Sebastian von Rotenhahn")]), _vm._v(". Bei meinen\nadligen Ehren . . .")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Geyer")]), _vm._v(". Zentauren seid ihr, aber\nkeine Adelsleut. Wo waren doch eure adligen Ehren, als es dem edlen\nFranziskus von Sickingen, höchstem Vorbild aller adligen Tugenden,\ndie Schanze verschlug wider den Pfaffen von Trier? Damalen sollt\nsich ein Edelmannskrieg anfahen. Wo blieb euer Beistand, da es not\ntat? In einen alten Harnischkasten haben sie des Sickingen edlen\nLeichnam gestopft, Köche und Spielleut haben ihn am Strick über den\nBerg heruntergeschleift. Wo waren da eure adligen Ehren? Euer Nam\nund Ehre: eine Handvoll Wind, von Pfaffen und Fürsten in Luft\ngeblasen.")]), _vm._v(" "), _c('p', {
    staticClass: "stage"
  }, [_vm._v("Die Gesandtschaft hat sich zurückgezogen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Wolf von Kastell")]), _vm._v(", "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("in der Tür, schreit zurück.")]), _vm._v(" Ihr Männer, hütet euch\nvor dem Geyer! Er ist des Franzosen heimlicher Diener, er liefert\neuch dem Franzosen aus! "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("Ab mit der\nGesandtschaft.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Tellermann")]), _vm._v(". Soll ich mich an sie\nmachen, Kapitän?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Geyer")]), _vm._v(". Gemach, Bruder, es ist Pech\nund Schwefel genung über meine Rüstung gelaufen. Hab gut Sorg, daß\nihnen strack sicheres Geleit gehalten werd bis in ihr\nGewahrsam.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Trabant")]), _vm._v(" "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("kommt,\nmeldet.")]), _vm._v(" Kapitän, haben sich viel hundert Weiber rottieret\nund dieshalb wie jenhalb der Mainbrücken ufgestellt. Sind in\nwillens, die Gesandtschaft beim Widerritt ufzuhalten, schwören, sie\nwollten's nit wieder in die Burg lassen, und sollt sie der Teufel\nnit daran hindern, vielmeh alles, was pfäffisch sei, von den\nKleppern reißen und in den Main stürzen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Geyer")]), _vm._v(". Blitz und Donner, was haben\nwir doch mit Weiberröcken zu schaffen! Frisch, Galgen ufgericht't!\nDen Profossen in sie arbeiten lassen, flugs aufknüpfen, was nit\nguttun will!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Flammenbecker")]), _vm._v(". Hast Stock und\nGalgen auch nit von kaiserlicher Majestät erworben.")]), _vm._v(" "), _c('p', {
    staticClass: "stage"
  }, [_vm._v("Trabant ab.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Link")]), _vm._v(". Brüder, itzt ist eine Stunde\nwarten zu lang. Nu frisch daran! Mit ganzer bäurischer Macht und\nGeschütz, mit "), _c('a', {
    staticClass: "pcalibre pcalibre1 pcalibre3 pcalibre2",
    attrs: {
      "id": "page39",
      "title": "joe_ebc/lac"
    }
  }), _vm._v("\nSturmbock, Tartsche und Leiter sei wider das Schloß gehandelt!\nDran! Dran! mit Gewalt und Gotteskraft, daß sie den grimmen Ernst\nwohl vermerken und Rittern und Knechten in der Besatzung blutbange\nwerd. Platzet sie an mit dem Geschütz . . .")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Löffelholz")]), _vm._v(". Mit was Geschütz soll\nman sie anplatzen? – Höret mir zu, liebe Brüder! Eins tut itzt vor\nallem not, und so ihr derselben Meinung seid und Gott euch\nerleuchtet, so gibt er euch noch diese Stunde den Wurf in die Hand.\nIch denke wohl, daß ihr mich genugsam kennt. Ich habe die\nevangelische Freiheit alleweil liebgehabt von ganzem Gemüt. Die\nHandvoll Bluts in meim Busen innen, die will ich getrost an den\nHandel setzen.")]), _vm._v(" "), _c('p', {
    staticClass: "leftmarg"
  }, [_vm._v("Gott hat uns bis hieher glücklich und wohl\ngeführet. Alle großen Köpfe und gewaltigen Hansen ducken sich und\nhaben die Flucht geben. Dannoch will mir das Herz nit so fast groß\nwerden und lustig. Bös Ahnen nestelt sich an mich, ob ich nit weiß,\nwarum.")]), _vm._v(" "), _c('p', {
    staticClass: "leftmarg"
  }, [_vm._v("Brüder, ein oberster Wille muß sein! Wir müssen\nein Haupt über uns setzen, einen gewaltig machen über alle Haufen\nder Bauernschaft. Das uneine Gespann stürzet den Pflug um. Ein\nWille ist oft meh denn tausend, eine Hand oft meh denn hundert, und\ndieweil ihr dreimal des Tages ein mehrers macht, kehrt sich der\nPövel im hellen Haufen mitnichten daran und macht alle Ordnung und\nArtikel zu einem Spott, Schmach und Gelächter.")]), _vm._v(" "), _c('p', {
    staticClass: "leftmarg"
  }, [_vm._v("Der Truchseß von Waldburg steht mit des\nSchwäbischen Bundes Heer in Rüstung wider uns. Dawider ist hoch\nvonnöten, daß wir in Zeiten uns schicken. Da ist ein einiger Mann\nund einiger, fester Will Reitergeschwader und Fußknecht, ein\nstrack, scharf Regiment ein gewaltiger Kriegshauf, gedient und\nerfahren im Feld. So ist mein Fürschlag und Meinung, daß man den\nFlorian Geyer erwählen und kiesen soll mit Bestallung gemeiner\nBauernschaft, sei es uf ein Jahr. Man soll ihm Räte beigeben . . .\n"), _c('span', {
    staticClass: "regie"
  }, [_vm._v("Unruhe.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Metzler")]), _vm._v(". Der Götz von Berlichingen\nsoll unser Hauptmann sein!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Bubenleben")]), _vm._v(" "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("springt auf.")]), _vm._v(" Brüder, man soll keinen Edelmann über\nuns setzen! Art läßt nit von Art. Ein Habicht wird niemals zur\nTaube, und ein Rittermäßiger wird nie zu einem evangelischen Bauern\nwerden! Es sollt überhaupt kein Ritter in diesem Rat sitzen! "), _c('a', {
    staticClass: "pcalibre pcalibre1 pcalibre3 pcalibre2",
    attrs: {
      "id": "page40",
      "title": "malosept/lac"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Tellermann")]), _vm._v(" "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("ist\nwiedergekehrt, schreit dazwischen.")]), _vm._v(" Es sollte kein Pfaff in\nunserem Rat sitzen!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Bubenleben")]), _vm._v(". Ei nun, es ist\nlandkundig, daß ihr Geyerschen nit viel haltet von Gottes Wort.\nNimmt mich auch nit wunder, kämpft ihr doch unter der schwarzen\nFahn! Habt ihr doch in der gottlosen Bande noire gedient, wo nichts\ndann Ächter, Gotteslästerer und Heiden innen sind. Ihr wollet Gott\nabsetzen, wir aber wollen ihn einsetzen und ihm allein dienen. So\nwird Gott uns auch einen Helden erwecken, wann das Stündlein\nschlägt . . .")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Löffelholz")]), _vm._v(", "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("zwischenrufend.")]), _vm._v(" Und wann er schon unter euch sitzet,\nso sehet ihr ihn doch nit.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Bubenleben")]), _vm._v(", "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("fanatisch.")]), _vm._v(" Gott wird einen Helden ausrüsten, dem\ngroßen Werke gewachsen. Der wird die Moab, Agag, Achab, Phalaris\nund Neros dieser Zeit von den Stühlen stoßen und ihnen die\nBluttaufe geben. Gemeiner Leute Kind wird er sein und keiner von\nden Rittern, die, ob sie gleich in Eisen gepanzert sind, so leise\nund fürsichtig gehen wie die Katzen auf dem Dachfirst. Sie schonen\nder Ihren allerwegen; verflucht aber ist jeder Gläubige, der sein\nSchwert vom Blute der Widersacher Christi fernhält. Itzt heißt es\ndie Hände baden in ihrem Blut und darin heiligen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Der Schultheiß")]), _vm._v(". Der Pfaff ist\nbesessen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Bubenleben")]), _vm._v(". Wollt ihr jetzt einen\nzum Obersten Hauptmann machen, so erwählet . . .")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Der Schultheiß")]), _vm._v(", "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("schnell.")]), _vm._v(" . . . den Bruder Bubenleben, Pfarrer zu\nMergentheim! "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("Gelächter.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Bubenleben")]), _vm._v(". Nein, nit mich, aber\nden Mann, welchen der fränkische Hauf über sich gesetzet: den Jacob\nKohl von Eifelstadt.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Löffelholz")]), _vm._v(", "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("zwischenrufend.")]), _vm._v(" Er kann alle großen Schwür.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Tellermann")]), _vm._v(". So feist er ist,\nbaumelt er dannoch dem Pfaffen am Gürtel.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Geyer")]), _vm._v(" "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("steht\nauf.")]), _vm._v(" Wer will halten rein sein Haus, der behalt Pfaffen und\nMönche draus.")]), _vm._v(" "), _c('p', {
    staticClass: "stage"
  }, [_vm._v("Geyers entschlossene Bewegung erregt Aufsehen in\nder Versammlung. Man beobachtet ihn in der Folge scharf. Er spricht\nintim mit Tellermann, dem Schultheiß und Löffelholz. Hippler und\nGötz flüstern und beobachten ebenfalls. Der Schultheiß und\nTellermann gestikulieren immer heftiger auf Geyer ein.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Kohl")]), _vm._v(". Brüder, wann das\nLöffelhölzlein auch schellig wird, das "), _c('a', {
    staticClass: "pcalibre pcalibre1 pcalibre3 pcalibre2",
    attrs: {
      "id": "page41",
      "title": "Teledahner/gary"
    }
  }), _vm._v(" schiert mich in keinem Weg. Meine\nbäurischen Brüder kennen mich.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Martin")]), _vm._v(", "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("zwischenrufend")]), _vm._v(". Aus der Trinkstuben!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Kohl")]), _vm._v(". Potz! Daß dich das Wetter\nerschlag! Soll ich es leugnen, daß mir der Wein ebenso\nwohlschmecket als einem Ritter? Der Teufel sollt mir die Lüg\ngesegnen. Meinst du, man soll nit in der Trinkstuben sitzen,\nsundern allweg hoch und uf Stelzen einhertreten, sich meh bedünken\nals andere bäurische Brüder im hellen Haufen? Soll man sich alleweg\naufblasen, wie die Geyerschen tun? »He da! Tretet aus dem Weg,\ndaher fahr "), _c('i', {
    staticClass: "calibre4"
  }, [_vm._v("ich!")]), _vm._v("« Das tu ich nit. Um mich ist alles\nglaslauter.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Martin")]), _vm._v(", "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("zwischenrufend")]), _vm._v(". Lauter Gläser und Kannen!\n"), _c('span', {
    staticClass: "regie"
  }, [_vm._v("Gelächter.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Kohl")]), _vm._v(". Jawohl, glaslauter ist alles\num mich.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Zwischenruf")]), _vm._v(". Würzburger\nJüdenwein!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Kohl")]), _vm._v(". Nit Würzburger Jüdenwein,\nsundern es ist glaslauter um mich. Ich halt mich nach meinem\nSchwur, und so mir vom ganzen hellen Haufen ufgelegt wird: tue das!\nso tu ich's, und: laß deine Hand von dem andern! so laß ich meine\nHand davon. Heimliche Praktiken und verräterische Anschläg treib\nich nit. Wählet man mich, so wählet man mich; wählet man mich nit,\nso wollt ich doch lieber am Galgen verfaulen, sollt mir der\nSchinder das Herz aus dem Leibe brennen, eh daß ich mich des\ntyrannischen Gewalts unterstünd.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Löffelholz")]), _vm._v(". Wer unterstehet sich\nhie des Gewalts?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Kohl")]), _vm._v(". Das, Bruder, fraget den\nFlorian Geyer!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Flammenbecker")]), _vm._v(". Brüder, wir brauchen\nkeinen Hauptmann über uns alle. Stoßen wir deshalb die kleinen\nTyrannen von den Stühlen, damit wir die großen daruf setzen? Es\ngibt hie Leute unter uns, die mögen ihre herrischen und teuflischen\nGelüsten nit unterdrucken. Sie setzen Profossen über uns,\nStockmeister und Schergen. Sie meinen uns mit Steckenknechten zu\nregnieren, schlimmer und grausamer, dann es unter dem Papsttum\ngewest. Sie haben hie zu Würzburg Galgen ufgericht't.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Geyer")]), _vm._v(" "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("schreit\ndazwischen")]), _vm._v(". Noch meh Galgen, und alle Weinsberger Blutbuben\ndaran gehenket!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Flammenbecker")]), _vm._v(", "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("rasend")]), _vm._v(". Alle Junker, Gutgewinner und Ächter daran\ngehenket! Zum Teufel mit allen gelben Sporen! Man muß euch durch\ndie Spieße jagen wie den "), _c('a', {
    staticClass: "pcalibre pcalibre1 pcalibre3 pcalibre2",
    attrs: {
      "id": "page42",
      "title": "elbinger/gary"
    }
  }), _vm._v(" Helfensteiner, euch vierteilen als die\nverfluchten Verräter und Bösewicht! "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("Gelächter\nder Ritter.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Hippler")]), _vm._v(". Bruder Geyer, stehet mir\nRed und Antwort. Es geht das Geschrei, die Euren hätten Gemein\ngehalten, Hauptleute, Obriste und Feldweibel des schwarzen Haufs\nhätten es in sie getrieben und jedermann persuadieret\nmeuterischerweis, und sei auch beschlossen worden im Ring: sie\nwollten in keinem Weg einen andern dulden, man setze dann Euch,\nBruder Geyer, zum Obristen-Feldhauptmann über alle Haufen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Geyer")]), _vm._v(". Da weiß ich nichts von, was\ngehet mich das an!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Götz")]), _vm._v(". Brüder, was sollen uns die\nTrabanten vor der Kirchenporten? Schicket sie doch heim.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Link")]), _vm._v(". Wem stehen sie zu?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Flammenbecker")]), _vm._v(". Sind vom schwarzen\nHäuf, stehen dem Florian Geyer zu.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Bubenleben")]), _vm._v(". Brüder, was will das\nwerden? Nit weit von hie, uf der Gassen, bin ich auf ein stark\nFähnlein gewappneter Knecht gestoßen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Löffelholz")]), _vm._v(". Sind für das\nBarfüßer-Kloster bestimmt, sollen Quartier darin nehmen um Friedens\nund Ordnung willen, damit es nit hie zu Würzburg mit Plündern,\nStehlen und Beschädigung Leibes und Gutes also türkisch zugehe wie\nanderwärts.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Link")]), _vm._v(". Die Bürgerschaft hat ein gut\nFähnlein aus allen Vierteilen ausmustern lassen und in das\nBarfüßer-Kloster gelegt. So werden wir selbst wissen Ordnung und\nFried aufrechterhalten.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Der Schultheiß")]), _vm._v(". Ei, Link, das\nFähnlein im Barfüßer-Kloster tuet es allen voran mit Schatzen,\nRanzionen und durch die Häuser laufen! Und wär es nit so, unter\nallen Haufen der Bauern sind unnütze Leut genung. Jaufkinder,\nLuderer und anderes Gesindel webert ein und aus durch die Tore.\nDawider ist gut, daß man ihnen ihr eigen Regiment zeige und\nBäurische wider Bäurische ufbiete.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Link")]), _vm._v(". Wird einer Bürgerschaft hie\nzu Würzburg nit wohl eingehen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Flammenbecker")]), _vm._v(". Es seien kein\nunnütze Leut im hellen Haufen!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Geyer")]), _vm._v(". Es gehe der Bürgerschaft\nwohl oder übel ein, es tut not, daß wir beizeiten anfahen, Ordnung\nund Zucht in die Haufen zu treiben. Lassen wir den Teufel fürder\ngewähren "), _c('a', {
    staticClass: "pcalibre pcalibre1 pcalibre3 pcalibre2",
    attrs: {
      "id": "page43",
      "title": "elbinger/gary"
    }
  }), _vm._v("\nmit Verwüstung Proviants, Getreid in den Main schütten, Wein aus\nden Fässern lassen laufen, wahrlich, meiner Seel, es wird bald\ndahin kommen, daß ein evangelischer Bruder im hellen Haufen wird\nmüssen mit blutigen Fingern nach einem Stück Hungerbrot graben!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Götz")]), _vm._v(". Was hab ich gesagt, Brüder?\nStoßen die Geyerschen zu uns, so fahet sich Zwietracht an und nimmt\nniemalen kein Ende meh.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Geyer")]), _vm._v(". Bruder Berlinger, wer hat\nmeh Zwietracht gesäet in die Haufen, ich oder Ihr?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Götz")]), _vm._v(". Ein jeder beuget und bücket\nsich, allein die Geyerschen bleiben auf ihrem Kopf, kümmern sich um\nden gemeinen Handel nit.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Tellermann")]), _vm._v(". Kotz Schweiß, Bruder\nBerlinger, habt ihr wohl unsrer geachtet, saget mir doch, als ihr,\ndu und der Metzler, euren Zug nähmet, wo wir und der schwarze Hauf\nvordem gezogen? Neun Städte uf'm Odenwald haben sich uns ufgetan\nund zugelobt. Hat es der Florian Geyer durchgesetzt, ward von den\nUnseren keinem Bürger ein Fensterlein zerworfen, keiner Magd ein\nFürfleck verrückt. Aber hernacher seid ihr kommen, alles\ngebrandschatzt, über Kisten und Keller gefallen, Weiber geschändet,\nviel hundert Wägen Plunders fort lassen schleppen. Bruder, als das\nist ruchbar worden in ganzer Gemeine des schwarzen Haufs, was\nWunders, daß ihnen die Wut ist ankommen. So habt "), _c('i', {
    staticClass: "calibre4"
  }, [_vm._v("ihr")]), _vm._v("\nZwietracht unter die Brüder gesäet! Die Städte, mit Eiden und\nPflichten uns verstrickt, ihr habt gemacht, daß sie mußten Eide und\nPflichten brechen und euch wiederum zugeloben.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Götz")]), _vm._v(". Sollte man euch lassen\ngewähren, ihr Geyerschen, der teuren evangelischen Freiheit\nerstünden meh Feinde über Nacht, dann es Krämer gibt in Venedig,\nSäufer in Sachsen, Säue in Pommern und Huren in Bamberg\ninsgesamt.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Geyer")]), _vm._v(". Wißt Ihr noch meh, Bruder\nBerlinger?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Götz")]), _vm._v(". Ihr habt uns den ganzen Adel\nfeind gemacht.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Geyer")]), _vm._v(". Ich hab den Artikelbrief\nvollstreckt.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Götz")]), _vm._v(". Es tut dannoch nit not. Ihr\nseid selber vordem ein Ritter gewest. Ist es nit schmählich,\nBruder, daß Ihr es allen vorantut mit Zerreißung fester Schlösser\nund Häuser des Adels, da Ihr doch jedem Pfeffersack Reverenz\nmachet, wenn er gleich nur mit der Zipfelhauben über die Stadtmauer\nherausdräuet? Die Häuser des Adels . . . "), _c('a', {
    staticClass: "pcalibre pcalibre1 pcalibre3 pcalibre2",
    attrs: {
      "id": "page44",
      "title": "MEsswein/gary"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Geyer")]), _vm._v(". Herunter mit ihnen, herunter\nmit allen verfluchten Rabennestern! Es muß ein Ende nehmen mit\nHeckenschinden und Staudenreiten. Meine weiland guten Gesellen vom\nAdel sollen lernen Besseres tun dann zwo Beine über ein Roß henken,\nHändel uf Gewinn treiben, Bauern schinden und schatzen, Kaufleut\nniederwerfen, verstricken oder in die stinkigen Türme werfen, ihnen\nHänd abhacken, Ohren abschneiden und dergleichen ritterlicher\nHandlungen meh. Ihr sollt fortan eine Tür haben, den Acker bauen\nund zu Fuß gehen wie andre Christenleut. Der Edelmann ist nit\nmeh . . .")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Götz")]), _vm._v(". Wie denkst du über des\nEdelmanns Wort, Bruder?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Geyer")]), _vm._v(". Wie über jedermanns Wort,\ndaß ein Wort ein Wort bleibe.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Götz")]), _vm._v(". Denk an Möckmühlen, als du\nnoch bestallter Hauptmann des Schwäbischen Bundes warst! Welche\nbündischen Hundsfötter haben mir damals Geleit zugesagt und\ngebrochen?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Geyer")]), _vm._v(". Nimm einen Löffel und friß\ndeine Lüge!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Hippler")]), _vm._v(" "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("erhebt\nsich")]), _vm._v(". Friede, ihr Brüder! – "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("Man hört\nschießen.")]), _vm._v(" Kotz, was ist das?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Götz")]), _vm._v(". Oha! Büberei!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Geschrei")]), _vm._v(", "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("tumultuarisch")]), _vm._v(". Büberei! Verrat!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Massenruf von außen")]), _vm._v(". Vivat Florian\nGeyer!")]), _vm._v(" "), _c('p', {
    staticClass: "stage"
  }, [_vm._v("Tumult und Panik in der ganzen Versammlung.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Geschrei")]), _vm._v(". Verrat! Meuterei!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Geyer")]), _vm._v(" "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("springt\nauf, schreit")]), _vm._v(": Ruhe, Brüder! Ein Hundsfott, wer von Verrat\nschreit. Hie steh ich und gelob ich, daß ich Amt und Bestallung nit\nanders will empfahen oder zur Hand nehmen, es sei mir denn\nübergeben vom Versammlungsrat gemeiner bäurischer Brüderschaft. Und\nwen sie über uns alle will mächtig machen, dem will ich mich\ngehorsam beugen und untertan sein, als einem evangelischen Bauern\ngeziemet und zusteht. Aber meine Meinung ist, liebe Brüder, daß man\neinen Kriegsrat erwähle, kundige und kriegserfahrene Leute\ndareinsetze und den bewegen lasse, was gen innen und außen zu tun\nund zu lassen sei. Wer aber der Meinung ist, daß das beschehe, der\nstoße sein Messer in diesen Ring. "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("Er zieht mit\nKreide einen Kreis auf der Kirchentür")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Tellermann")]), _vm._v(", "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("sein Messer zückend")]), _vm._v(". Dem Truchsessen von "), _c('a', {
    staticClass: "pcalibre pcalibre1 pcalibre3 pcalibre2",
    attrs: {
      "id": "page45",
      "title": "MEsswein/gary"
    }
  }), _vm._v(" Waldburg,\nbestalltem Obersten Hauptmann des Bundes zu Schwaben, mitten ins\nHerz! "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("Er stößt zu")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Bubenleben")]), _vm._v(". Dem Bischof Konrad von\nThüringen mitten ins Herz! "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("Er stößt\nzu")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Flammenbecker")]), _vm._v(". Dem Georgen Truchseß\nvon Waldburg, bestalltem Obersten Hauptmann des Bundes zu Schwaben,\ndem Bluthund von Wurzach, mitten ins Herz! "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("Ebenso")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Ein Weinsberger")]), _vm._v(". Rache für Wurzach!\nRache für die siebentausend gemordeten Brüder! Dem Truchsessen von\nWaldburg mitten ins Herz! "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("Ebenso")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Löffelholz")]), _vm._v(". Allen Fuggern und\nWelsern mitten ins Herz! "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("Ebenso")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Sartorius")]), _vm._v(". Dem Truchsessen von\nWaldburg mitten ins Herz! "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("Ebenso")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Erster Bauernhauptmann")]), _vm._v(". Allen\nSchindern und Schabern des Volkes mitten ins Herz! "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("Ebenso")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Zweiter Bauernhauptmann")]), _vm._v(",\n"), _c('span', {
    staticClass: "regie"
  }, [_vm._v("zu Grumbach")]), _vm._v(". Flugs, Bruder, sage du auch\ndeinen Spruch!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Martin")]), _vm._v(". Allen pfäffischen Königen\nund königlichen Pfaffen mitten ins Herz! "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("Ebenso")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Wilhelm von Grumbach")]), _vm._v(". Dem Bischof\nKonrad von Würzburg mitten ins Herz! "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("Ebenso")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Hippler")]), _vm._v(". Dem Kanzler der Herzöge\nvon Bayern, bestalltem Rat des Bundes zu Schwaben, dem\ngottverfluchten Leonhard Eck, mitten ins Herz! "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("Ebenso")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Dritter Bauernhauptmann")]), _vm._v(". Dem\nTruchsessen von Waldburg mitten ins Herz! "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("Ebenso")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Geyer")]), _vm._v(". Der deutschen Zwietracht\nmitten ins Herz! "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("Ebenso")]), _vm._v(". "), _c('a', {
    staticClass: "pcalibre pcalibre1 pcalibre3 pcalibre2",
    attrs: {
      "id": "page46",
      "title": "MEsswein/gary"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5ff7c0e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0004.vue
// module id = 66
// module chunks = 0